import { render, staticRenderFns } from "./TopLinks.vue?vue&type=template&id=052861a5&scoped=true&"
import script from "./TopLinks.vue?vue&type=script&lang=js&"
export * from "./TopLinks.vue?vue&type=script&lang=js&"
import style0 from "./TopLinks.vue?vue&type=style&index=0&id=052861a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052861a5",
  null
  
)

export default component.exports